import { useTranslation } from "react-i18next";
import { DataTable } from "../../../../../../shared/components/data-table/DataTable";
import { Badge } from "../../../../../../shared/components/badge/Badge";
import { formatToPercent } from "../../../../../../shared/lib/utils";

const ClientPlatformMarginsChangelogTable = ({ data }) => {
  const { t } = useTranslation();

  const columns = [
    {
      accessorKey: "timestamp",
      header: t("clientPlatformMargins.changelog.table.timestamp"),
    },
    {
      accessorKey: "username",
      header: t("clientPlatformMargins.changelog.table.username"),
    },
    {
      accessorKey: "operation",
      header: t("clientPlatformMargins.changelog.table.operation"),
      cell: ({ row }) => {
        const operation = row.original.operation;
        switch (operation) {
          case "CREATE":
            return (
              <Badge className="border-transparent bg-[#28A745] text-primary-foreground shadow hover:bg-[#28A745]/80">
                {t("defaults.createLabel")}
              </Badge>
            );
          case "UPDATE":
            return (
              <Badge className="border-transparent bg-[#60a1ff] text-primary-foreground shadow hover:bg-[#60a1ff]/80">
                {t("defaults.updateLabel")}
              </Badge>
            );
          case "DELETE":
            return (
              <Badge className="border-transparent bg-[#DC3545] text-primary-foreground shadow hover:bg-[#DC3545]/80">
                {t("defaults.deleteLabel")}
              </Badge>
            );
          default:
            return (
              <Badge className="border-transparent bg-[#FFC107] text-primary-foreground shadow hover:bg-[#FFC107]/80">
                {t("defaults.unknown")}
              </Badge>
            );
        }
      },
    },
    {
      accessorKey: "client",
      header: t("clientPlatformMargins.changelog.table.client"),
      cell: ({ row }) => <div>{row.original.client.name}</div>,
    },
    {
      accessorKey: "platform",
      header: t("clientPlatformMargins.changelog.table.platform"),
      cell: ({ row }) => <div>{row.original.platform.name}</div>,
    },
    {
      accessorKey: "margin",
      header: t("clientPlatformMargins.changelog.table.margin"),
      cell: ({ row }) => <div>{formatToPercent(row.original.margin)}</div>,
    },
    {
      accessorKey: "beginDate",
      header: t("clientPlatformMargins.changelog.table.beginDate"),
    },
    {
      accessorKey: "endDate",
      header: t("clientPlatformMargins.changelog.table.endDate"),
    },
    {
      accessorKey: "comments",
      header: t("clientPlatformMargins.changelog.table.comments"),
    },
    {
      accessorKey: "marginInPlatform",
      header: t("clientPlatformMargins.changelog.table.marginInPlatform"),
      cell: ({ row }) => (
        <Badge
          variant={row.getValue("marginInPlatform") ? "outline" : "secondary"}
        >
          {row.getValue("marginInPlatform")
            ? t("defaults.activeLabel")
            : t("defaults.inactiveLabel")}
        </Badge>
      ),
    },
  ];

  return <DataTable columns={columns} data={data} />;
};

export default ClientPlatformMarginsChangelogTable;
